import { render } from "./WhiteboardDialog.vue?vue&type=template&id=c90efdee"
import script from "./WhiteboardDialog.vue?vue&type=script&lang=js"
export * from "./WhiteboardDialog.vue?vue&type=script&lang=js"

import "./WhiteboardDialog.vue?vue&type=style&index=0&id=c90efdee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__